<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10elxYr/tc-custom/9781600379574.jpg?1705201833702" alt="This image is the cover for the book SuperStar Selling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">SuperStar Selling
      </h1>
      <p class="bookDescription body article font2">
        <p>Superstars are made, not born. Find your key to becoming a Superstar by doing what the Superstars do. SuperStar Selling: 12 Keys to Becoming a Sales SuperStar takes you step-by-step through constructing the foundation that will propel you to superstardom. You'll learn how to identify your sales strengths and then find the products or services, the markets, the marketing methods, and the selling process that will highlight your selling strengths and minimize your weaknesses. Whether you are new to sales or an old pro, SuperStar Selling will show you how to create the sales business and income you want. Not a book for the casual reader, this in-depth study is for the salesperson or manager who is serious about a change.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul McCord
      </h2>
      
      <p class="authorDescription body article">PAUL McCORD is a speaker, sales trainer, and consultant with over twenty years' experience training sales personnel from every imaginable industry. His sales training and consulting company, McCord and Associates, is a Houston-based firm that focuses on helping small to medium-sized companies develop their sales teams.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6baec535